import routerOptions0 from "/Users/baegjeong-gyu/Desktop/nuxt/moichat-nuxt/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}